import { fromEntries } from './from-entries';
export const DEFAULT_KEYS_TO_MASK = ['authorization'];
export const MASK_PATTERN = 'XXXXX';
export const maskedObject = (obj, processedObjects = new Map()) => {
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }
    // Safety guard to prevent infinite loops with self-referencing objects
    if (processedObjects.has(obj)) {
        // eslint-disable-next-line @glovo/no-console
        console.warn('[RUM] Unable to mask self-referencing object');
        return obj;
    }
    processedObjects.set(obj, true);
    return fromEntries(Object.entries(obj).map(([key, value]) => {
        const shouldMaskKey = DEFAULT_KEYS_TO_MASK.includes(key.toLowerCase());
        if (!shouldMaskKey && typeof value === 'object' && value !== null) {
            return [key, maskedObject(value, processedObjects)];
        }
        return shouldMaskKey ? [key, MASK_PATTERN] : [key, value];
    })); // Casting due to limitation in fromEntries types
};
//# sourceMappingURL=masked-object.js.map